import { axiosInstance, handleApiRequest } from './apiClient';
import { ReadmeResponse } from 'types/readme';

const readmeAPI = {
  getReadmeUrl: async () => {
    return handleApiRequest<ReadmeResponse>(axiosInstance.get(`/readme`));
  },
};

export default readmeAPI;
